import { Deserializable } from '../protocols/deserializable';
import { Beneficiary } from '../../views/beneficiaries/models/beneficiary';

export class BeneficiaryChangeSubmissionData implements Deserializable {
  public beneficiaries!: Beneficiary[];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.beneficiaries.length) {
      this.beneficiaries = Deserialize?.arrayOf(Beneficiary, this?.beneficiaries);
    }
  }
}
